import { Button, Form, Upload } from "antd";
import { useContext, useState } from "react";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import { mConstants } from "../../../../helper/constants";
import { dialog } from "../../../../helper/dialog";
import { RouteContext } from "../../user/screen/components/route.context";
import { planService } from "../service/plan.service";

function UploadCustomerPlan() {
  const { dispatch } = useContext(SpinContext);
  const { state } = useContext(RouteContext);
  const [file, setFile] = useState<File>();

  const onFinish = (values: any) => {
    dispatch({ type: spinActions.BLOCK });

    if (file)
      planService
        .uploadCustomerPlan(file, state.routeId)
        .then(() => {
          dialog.success(`Харилцагчийн төлөвлөгөө амжилттай хууллаа.`);
          dispatch({ type: spinActions.UNBLOCK });
        })
        .catch((e) => {
          dispatch({ type: spinActions.UNBLOCK });
        });
  };

  const onUpload = async (options: any) => {
    const { onSuccess, file } = options;
    setFile(file);
    onSuccess(file);
  };

  return (
    <>
      <MPageHeader crumbs={["Харилцагчийн төлөвлөгөө"]} />
      <div className="content">
        <div className="card">
          <div className="card-header">
            <h6 className="card-title">Төлөвлөгөөний файл хуулах</h6>
          </div>
          <div className="card-body">
            <Form onFinish={onFinish}>
              <div className="form-group">
                <label>Файл</label>
                <Form.Item
                  name="file"
                  rules={[
                    {
                      required: true,
                      message: "Файлыг сонгоно уу.",
                    },
                  ]}
                >
                  <Upload
                    multiple={false}
                    accept=".xlsx"
                    customRequest={onUpload}
                  >
                    <Button icon={<i className="icon-file-upload mr-2" />}>
                      Төлөвлөөний файлыг хуулах
                    </Button>
                  </Upload>
                </Form.Item>
                <a
                  target="_blank"
                  href={
                    mConstants.API_URL +
                    mConstants.PUBLIC_FILE_DOWNLOAD_PATH +
                    "customer_plan_draft.xlsx"
                  }
                >
                  Драфт файл татах
                </a>
              </div>
              <div className="text-right">
                <button type="submit" className="btn btn-primary">
                  Хадгалах <i className="icon-floppy-disk ml-2" />
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}

export default UploadCustomerPlan;
